(function () {
  var STYLE_ID = 'netsteps-retraced-style';
  var OPEN_CLASS = 'netsteps-retraced-open';
  var READY_CLASS = 'is-retraced-ready';
  var CHECK_MS = 400;
  var GIVE_UP_MS = 12000;
  var CSS =
    '.overflow-scroll { overscroll-behavior: contain; }' +
    '.relative.h-800.rounded-2xl {' +
    '  width: min(520px, calc(100vw - 24px)) !important;' +
    '  max-width: none !important;' +
    '  height: min(960px, calc(100dvh - 48px)) !important;' +
    '  max-height: none !important;' +
    '}';

  var savedScrollY = null;

  function restoreScroll(y) {
    window.scrollTo({ top: y, left: 0, behavior: 'instant' });
  }

  function syncOpen(root) {
    var panel = root.querySelector('.fixed.z-max');
    var isOpen = !!panel && panel.classList.contains('top-0');
    var html = document.documentElement;
    var wasOpen = html.classList.contains(OPEN_CLASS);
    if (isOpen === wasOpen) return;

    if (isOpen) {
      savedScrollY = window.scrollY;
      html.classList.add(OPEN_CLASS);
      return;
    }

    html.classList.remove(OPEN_CLASS);
    if (savedScrollY === null) return;
    var y = savedScrollY;
    savedScrollY = null;
    restoreScroll(y);
    requestAnimationFrame(function () {
      restoreScroll(y);
    });
    window.setTimeout(function () {
      restoreScroll(y);
    }, 250);
  }

  function setupOverlay(host) {
    var root = host.shadowRoot;
    if (!root || root.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    root.appendChild(style);

    new MutationObserver(function () {
      syncOpen(root);
    }).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    syncOpen(root);
  }

  function refreshAccordionHeight(tab) {
    if (!tab || tab.getAttribute('data-aria-expanded') !== 'true') return;
    var wrap = tab.querySelector('[data-accordeon-content-wrap]');
    var content = tab.querySelector('[data-accordeon-content]');
    if (!wrap || !content) return;
    wrap.style.maxHeight = content.scrollHeight + 24 + 'px';
  }

  function buttonLooksReady(btn) {
    if (!btn) return false;
    var root = btn.shadowRoot;
    if (!root) return false;

    var text = (root.textContent || '').replace(/\s+/g, ' ').trim();
    if (text.length > 2) return true;

    var interactive = root.querySelector('button, a, [role="button"], [data-retraced-overlay]');
    if (interactive) {
      var r = interactive.getBoundingClientRect();
      if (r.height > 8 && r.width > 8) return true;
    }

    var hostRect = btn.getBoundingClientRect();
    return hostRect.height > 12 && hostRect.width > 12 && root.childElementCount > 0;
  }

  function resolveTab(host, hasData) {
    var tab = host.closest('[data-retraced-tab], .product-content-tab--retraced');
    if (!tab) return;

    if (hasData) {
      tab.classList.add(READY_CLASS);
      refreshAccordionHeight(tab);
      return;
    }

    tab.classList.remove(READY_CLASS);
    tab.setAttribute('hidden', '');
    tab.style.display = 'none';
  }

  function watchButtonHost(host) {
    if (!host || host.getAttribute('data-retraced-watched') === 'true') return;
    host.setAttribute('data-retraced-watched', 'true');

    var btn = host.querySelector('retraced-button-verified');
    if (!btn) {
      resolveTab(host, false);
      return;
    }

    var settled = false;
    var started = Date.now();

    function finish(hasData) {
      if (settled) return;
      settled = true;
      resolveTab(host, hasData);
    }

    function tick() {
      if (settled) return;

      if (buttonLooksReady(btn)) {
        finish(true);
        return;
      }

      if (Date.now() - started >= GIVE_UP_MS) {
        finish(false);
        return;
      }

      window.setTimeout(tick, CHECK_MS);
    }

    new MutationObserver(function () {
      if (buttonLooksReady(btn)) finish(true);
    }).observe(btn, { childList: true, subtree: true, attributes: true });

    if (btn.shadowRoot) {
      new MutationObserver(function () {
        if (buttonLooksReady(btn)) finish(true);
      }).observe(btn.shadowRoot, { childList: true, subtree: true, attributes: true });
    }

    tick();
  }

  function scanOverlays() {
    document.querySelectorAll('[data-retraced-overlay]').forEach(setupOverlay);
  }

  function scanHosts() {
    document.querySelectorAll('[data-retraced-host]').forEach(watchButtonHost);
  }

  function init() {
    scanOverlays();
    scanHosts();
    new MutationObserver(function () {
      scanOverlays();
      scanHosts();
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
